import { COLLECTION_NAME } from ".";
import { planConverter } from "db/converters";
import { useFetchActive } from "services/common";

export const useFetchPlans = () => {
  const { data, loading, error } = useFetchActive(
    COLLECTION_NAME,
    planConverter
  );
  return {
    plans: data,
    loading,
    error,
  };
};
